import React, { useCallback, useContext } from 'react'
import useTourV2PurchasableOptionDetails from 'hooks/TourV2/useTourV2PurchasableOptionDetails'
import { TourV2ContentSections } from 'constants/tours'
import PriceRowPriceWithCaption from 'components/Luxkit/PricePoints/PriceRowPriceWithCaption'
import PriceRowCaption from 'components/Luxkit/PricePoints/PriceRowCaption'
import OfferPageStickyFooter from 'components/OfferPage/OfferPageStickyFooter'
import ModalContext from 'contexts/ModalContext'
import { useIsMobileScreen } from 'lib/web/deviceUtils'
import TourV2DepartureBookingModal from '../Departures/TourV2DepartureBookingModal'
import withOfferPageState from 'contexts/OfferPage/withOfferPageState'

interface Props {
  purchasableOption?: Tours.TourV2OfferPurchasableOption
  onScrollTo: (section: TourV2ContentSections) => void
  visible: boolean;
  offer: Tours.TourV2Offer;
}

function TourV2StickyFooter(props: Props) {
  const { purchasableOption, onScrollTo, visible, offer } = props

  const purchasableOptionDetails = useTourV2PurchasableOptionDetails(purchasableOption)

  const isMobile = useIsMobileScreen()
  const showModal = useContext(ModalContext)
  const onCheckAvailability = useCallback(() => {
    if (isMobile) {
      showModal(<TourV2DepartureBookingModal offer={offer} />)
    } else {
      onScrollTo(TourV2ContentSections.DEPARTURES)
    }
  }, [isMobile, offer, onScrollTo, showModal])

  return (
    <OfferPageStickyFooter visible={visible} callToActionCopy="Check Availability" onCTAClick={onCheckAvailability}>
      {!!purchasableOptionDetails && <div>
        <PriceRowPriceWithCaption
            size="M"
            caption="From"
            price={purchasableOptionDetails.pricePerPerson}
            saleUnit="person"
          />
        <PriceRowCaption>
          {purchasableOptionDetails.roomTypeName}
        </PriceRowCaption>
      </div>}
    </OfferPageStickyFooter>
  )
}

type MappedProps = Pick<Props, 'offer'>

export default withOfferPageState((state): MappedProps => ({
  offer: state.tourV2Offer!,
}))(TourV2StickyFooter)
